export default "__VITE_ASSET__c5f60fda__"